import React, { useState } from 'react';
import { motion } from 'framer-motion'
import './Timeline.css';

const Timeline = () => {
    // Define state to manage visibility of job details
    const [visibleJobIndex, setVisibleJobIndex] = useState(null);

    // Function to toggle visibility
    const toggleJobDetails = (index) => {
        setVisibleJobIndex(visibleJobIndex === index ? null : index);
    };

    // Define an array of job entries
    const jobEntries = [
        {
            title: 'Software Engineer',
            duration: 'Aug 2020 - Nov 2023',
            location: 'India',
            responsibilities: [
                'Developed responsive UI/UX web pages and features for an e-commerce site, fixed code defects, and boosted user engagement, increasing conversion rates by 20%.',
                'Optimized web performance, reducing load times by 30% by minification and lazy loading.',
                'Implemented Google Analytics and established GDPR compliance, improving data accuracy by 25% and user tracking efficiency by 30%.',
                'Gathered client requirements and provided features and deliverables estimations.',
                'Assured AA accessibility standards (WAGC) were met, such as creating documentation for best practices, establishing a standard accessibility checklist for developers, and facilitating knowledge shares.'
            ],
        },
        {
            title: 'Assistant Software Engineer',
            duration: 'Aug 2020 - Sept 2022',
            location: 'India',
            responsibilities: [
                'Customized pages based on the client requirement.',
                'Integrated third-party modules and customized them to meet the theme requirement.',
                'Verified the pages and components are Americans with Disabilities Act Standards for Accessible Design (ADA) compliant.',
                'Worked with the real-time Frog API for sales order tracking and history.'
            ],
        }
    ];

    return (
        <>
            <h2 className="numbered-heading">Work Experience</h2>
            <div className="welcome-container">
                <div className="CV-grid">
                    <div className="CV-grid-column">
                        <div className="CV-jobs">
                            <div className="overall-work experience">
                                <div className="company-experience">
                                    <h3 className="company-name">Tata Consultancy Services</h3>
                                    <small className="CV-timeline-heading-duration">Aug 2020 - Nov 2023</small>
                                    <small className="CV-timeline-heading-location">INDIA</small>
                                    {jobEntries.map((job, index) => (
                                        <section key={index} className="CV-timeline CV-job">
                                            <div className='new-total-block' onClick={() => toggleJobDetails(index)}>
                                                <div className="CV-timeline-heading" >
                                                    <span className="CV-timeline-heading-title">{job.title}</span>
                                                    <small className="CV-timeline-heading-duration">{job.duration}</small>

                                                </div>
                                                <span className="CV-timeline-heading-arrow">
                                                    {visibleJobIndex === index ? '▼' : '▶'}
                                                </span>
                                            </div>
                                            {visibleJobIndex === index && (
                                                <motion.ul
                                                    className="CV-timeline-details"
                                                >
                                                    {job.responsibilities.map((responsibility, idx) => (
                                                        <motion.li
                                                            key={idx}
                                                            className="CV-job-timeline-item"
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 1, delay: idx * 0.1 }}
                                                        >
                                                            {responsibility}
                                                        </motion.li>
                                                    ))}
                                                </motion.ul>
                                            )}
                                        </section>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Timeline;
